import React from 'react';
import Dotdotdot from 'react-dotdotdot';
import { CallToAction } from 'components/atoms/callToAction';
import { Image } from 'components/atoms/image';

const AwardCardMobile = props => {
  const data = props.data;

  const margin = data.items < 2 ? '-8vw' : {};
  const dataMargin = data.items < 2 ? '-9vw' : {};

  const renderOverlayButton = (
    <div className={'explore'}>
      <CallToAction
        text={'READ MORE'}
        mode={'transparent'}
        type={'link'}
        onClick={() => window.open(data.pdf_path, '_blank')}
        size={'small'}
        isMobile="true"
      />
    </div>
  );

  return (
    <div className="award_mobile_section" style={{ marginLeft: margin }}>
      <div className="award_image_mobile">
        <Image
          src={data.mobile_picture}
          alt="Award"
          className="image_award"
          thumbNail={data.media_path_thumbnail_mobile}
        />
      </div>
      {!data.type ? (
        <div style={{ marginLeft: dataMargin }}>
          <p className="awards-date">
            {data.awarded_at} /{' '}
            {new Date(data.awarded_on).toString().slice(11, 15)}
          </p>
          <h3 className="awards-authority">{data.authority}</h3>
          <Dotdotdot clamp={2} tagName={'p'} className={'project-name'}>
            {data.award_name}
          </Dotdotdot>
        </div>
      ) : (
        <h4 className="awards-date" style={{ marginLeft: dataMargin }}>
          {data.published_on}
        </h4>
      )}
      {!data.type && data.isProjectNameVisible ? (
        data.project_name ? (
          <h4 className="awards-location" style={{ marginLeft: dataMargin }}>
            {data.project_name + ', ' + data.city_name}
          </h4>
        ) : data.award_heading && !data.project_name ? (
          <h4 className="awards-location" style={{ marginLeft: dataMargin }}>
            {data.award_description}
          </h4>
        ) : (
          ''
        )
      ) : null}
      {data.type === 'news_card' ? (
        <h2 className="awards-location">{data.news_book_name}</h2>
      ) : null}
      {data.show_read_more ? renderOverlayButton : null}
    </div>
  );
};
export default AwardCardMobile;
